import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  Label,
  ResponsiveContainer,
} from 'recharts';
import labeling from './labeling';

// Polar series supported here are pie and donut chart.
const PolarSeries = ({
  data = [],
  elementMap,
  centerLabel,
  visType = 'pie',
  labelSetForData,
  labelMap,
  chartClick,
}) => {
  // Grab the last key - usually it is either a sum prop or "amount", just not "name".
  const dataKey = (data && data[0]) ? Object.keys(data[0]).pop() : '';
  return (
    <ResponsiveContainer>
      <PieChart>
        <Pie
          data={data}
          dataKey={dataKey}
          {...(visType === 'donut') && { innerRadius: '50%' }}
          legendType="circle"
          onClick={chartClick}
          isAnimationActive={false}
          label
        >
          {
            data.map(item => elementMap[item.name] && (
              <Cell
                key={item.name}
                name={labeling(item.name, labelSetForData, labelMap)}
                fill={elementMap[item.name].color}
              />
            ))
          }
          <Label position="center">
            {centerLabel}
          </Label>
        </Pie>
        <Legend />
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PolarSeries;
